export const DEFAULT_ICON_URL = 'ui-avatars'
export const DEFAULT_STOCK_ICON_URL = 'https://images.pexels.com'
